import { useEffect } from 'react'
import { useLexicalComposerContext } from '@lexical/react/LexicalComposerContext'
import { $getSelection, $isRangeSelection, $getRoot, $createParagraphNode, $createTextNode } from 'lexical'

export function InsertTextPlugin({ insertRef }) {
  const [editor] = useLexicalComposerContext()

  useEffect(() => {
    insertRef.current.insertText = text => {
      editor.update(() => {
        const selection = $getSelection()
        if ($isRangeSelection(selection)) {
          selection.insertText(text)
        } else {
          const root = $getRoot()
          let para = root.getLastChild()
          if (!para || para.getType() !== 'paragraph') {
            para = $createParagraphNode()
            root.append(para)
          }
          para.append($createTextNode(text))
        }
      })
    }
    insertRef.current.editor = editor
  }, [editor, insertRef])

  return null
}
